export enum LegalFormalitiesRoute {
  empty = '',
  capitalDeposit = 'capital-deposit',
  accountsApproval = 'accounts-approval'
}
